import { FC } from "react";
import "./styles.scss";
import { PageShell } from "../PageShell";
import { useTranslation } from "../../../hooks/useTranslation";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import platformShowcase from "../../../assets/images/landing/platform-showcase.png";

/** The four Key Features, each with its icon (board 357). */
const FEATURES = [
  { n: 1, Icon: PeopleAltOutlinedIcon },
  { n: 2, Icon: MapOutlinedIcon },
  { n: 3, Icon: GroupsOutlinedIcon },
  { n: 4, Icon: EventRepeatOutlinedIcon },
];

export const PlatformPage: FC = () => {
  const { p } = useTranslation("landing_platform");

  return (
    <PageShell>
      <div className="landing-platform-page">
        <h1 className="landing-platform-page__heading">{p("heading")}</h1>
        <p className="landing-platform-page__subtitle">{p("subtitle")}</p>
        <p className="landing-platform-page__tagline">{p("tagline")}</p>

        <div className="landing-platform-page__media">
          <img
            src={platformShowcase}
            alt={p("showcase_alt")}
            className="landing-platform-page__image"
          />
        </div>

        <h2 className="landing-platform-page__section-heading">{p("features_heading")}</h2>
        <ul className="landing-platform-page__list">
          {FEATURES.map(({ n, Icon }) => (
            <li key={n} className="landing-platform-page__feature">
              <span className="landing-platform-page__feature-icon" aria-hidden="true"><Icon fontSize="small" /></span>
              <strong className="landing-platform-page__feature-title">{p(`feature_${n}_title`)}</strong>
              <span className="landing-platform-page__feature-text">{p(`feature_${n}_text`)}</span>
            </li>
          ))}
        </ul>
      </div>
    </PageShell>
  );
};
